import React from 'react'

const DonatePanel = ({ widgets }) =>
  <div className="plg-donate" data-widget-id={widgets.donate} />

export default DonatePanel
